import React from 'react';

import { Badge, Button } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';
import PropTypes from 'prop-types';

import { blackberry, coolGrey, grape, greyStroke, softPurpleLight, white } from 'lib/css/colors';

function TabBar({ tabs, activeKey, onSelect }) {
  return (
    <div className={css(styles.tabs)} role="tablist">
      {tabs.map(tab => {
        const active = activeKey === tab.key;
        return (
          <Button
            key={tab.key ?? 'all'}
            variant="link"
            role="tab"
            aria-selected={active}
            className={css(styles.tabButton, active && styles.tabButtonActive)}
            onClick={() => onSelect(tab.key)}
          >
            {tab.label}
            {tab.count != null && (
              <Badge className={css(styles.countBadge, active && styles.countBadgeActive)}>
                {tab.count}
              </Badge>
            )}
          </Button>
        );
      })}
    </div>
  );
}

const styles = StyleSheet.create({
  tabs: {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: 4,
    marginTop: 4,
    marginBottom: 20,
    borderBottom: `1px solid ${greyStroke}`,
  },
  tabButton: {
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '3px solid transparent',
    color: coolGrey,
    fontWeight: 700,
    fontSize: 14,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    padding: '14px 22px',
    marginBottom: -1,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    transition: 'color 120ms ease, border-color 120ms ease, background-color 120ms ease',
    ':hover': {
      color: blackberry,
      backgroundColor: softPurpleLight,
    },
    ':focus': {
      outline: 'none',
      boxShadow: `0 0 0 3px ${softPurpleLight}`,
      borderRadius: 4,
    },
  },
  tabButtonActive: {
    color: grape,
    borderBottomColor: grape,
    backgroundColor: 'transparent',
    ':hover': {
      color: grape,
      backgroundColor: 'transparent',
    },
  },
  countBadge: {
    backgroundColor: softPurpleLight,
    color: blackberry,
    fontSize: 11,
    fontWeight: 700,
    padding: '4px 8px',
    borderRadius: 999,
  },
  countBadgeActive: {
    backgroundColor: grape,
    color: white,
  },
});

TabBar.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string.isRequired,
      count: PropTypes.number,
    }),
  ).isRequired,
  activeKey: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default TabBar;
